import { styled } from '@mui/material';
import { Button, Checkbox, Divider, IconButton, Radio, RadioGroup, Stack, Text } from 'shell/components';

const FilterCourse = ({ sortKey, filterKey, onClick: handleClick, onClose: handleClose, resetFilterSort }) => {
    return (
        <Stack>
            <IconButton
                sx={{ alignSelf: 'flex-end' }}
                aria-label={'close'}
                kind={'exit'}
                size={'medium'}
                variant={'square'}
                onClick={handleClose}
            />
            <Stack alignItems={'center'} direction={'row'} justifyContent={'space-between'}>
                <Text component={'h1'} variant={'h6'} weight={'semibold'}>
                    Sort By
                </Text>
                <Button variant={'tertiary'} onClick={resetFilterSort}>
                    Reset All
                </Button>
            </Stack>
            <Stack>
                <CustomRadioGroup
                    aria-label={'sort by'}
                    value={sortKey}
                    onChange={(_, value) => handleClick('SORT', value)}
                >
                    <Radio label={'Course Name A-Z'} labelPlacement={'start'} value={'titlea-z'} />
                    <Radio label={'Course Name Z-A'} labelPlacement={'start'} value={'titlez-a'} />
                </CustomRadioGroup>
            </Stack>
            <Divider sx={{ margin: '24px 0px' }} />
            <Text component={'h1'} variant={'h6'} weight={'semibold'}>
                Filters
            </Text>
            <CustomText color={'light'} variant={'p1'}>
                Course Status
            </CustomText>
            <CustomStack>
                <Checkbox
                    checked={filterKey.includes('inProgress')}
                    label={'In Progress'}
                    labelPlacement={'start'}
                    onChange={() => handleClick('STATUS', 'inProgress')}
                />
                <Checkbox
                    checked={filterKey.includes('future')}
                    label={'Future'}
                    labelPlacement={'start'}
                    onChange={() => handleClick('STATUS', 'future')}
                />
                <Checkbox
                    checked={filterKey.includes('past')}
                    label={'Past'}
                    labelPlacement={'start'}
                    onChange={() => handleClick('STATUS', 'past')}
                />
            </CustomStack>
        </Stack>
    );
};

const CustomRadioGroup = styled(RadioGroup)(() => {
    return {
        '& label': {
            justifyContent: 'space-between',
        },
    };
});

const CustomText = styled(Text)(({ theme }) => {
    return {
        margin: theme.spacing(2, 0, 1),
    };
});

const CustomStack = styled(Stack)(({ theme }) => {
    return {
        paddingLeft: theme.spacing(2),
        '& label': {
            justifyContent: 'space-between',
        },
    };
});

export default FilterCourse;
